module.exports = __webpack_public_path__ + "images/new-products/ECOLD-GLS-89RR-f6b37b845aeeccfa3e42a01618e0d1de.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/new-products/ECOLD-GLS-89RR.jpg
 ** module id = 287
 ** module chunks = 0
 **/